import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import API, { base } from "api.js";
import NewLogo from "assets/images/new-logol.svg";
import NewLogo2 from "assets/images/new-logol-2.png";
import loginArrow from "assets/images/arrow_drop_down.svg"
import { isIndia as detectIndia } from "utils/isIndia";

const Header = React.memo(() => {
  const location = useLocation();
  const activePath = location.pathname;
  const isLoggedIn = useSelector((state) => state.token);
  const [isIndia, setIsIndia] = useState(false);

  const [staffFlag, setStaffFlag] = useState(false);
  const [isMainSite, setIsMainSite] = useState(false);
  const [logoIcon, setLogoIcon] = useState("");
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [isCoursesOpen, setIsCoursesOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const coursesDropdownRef = useRef(null);
  const loginDropdownRef = useRef(null);

  // Memoized path checks
  const coursesPaths = useMemo(
    () => [
      "/pte-core",
      "/pte-online-coaching",
      "/pte-coaching-classes-parramatta",
      "/pte-coaching-sydney",
      "/naati-ccl-online-coaching",
      "/naati-coaching-classes-parramatta",
      "/naati-ccl-coaching-sydney",
      "/ielts-coaching-parramatta",
    ],
    []
  );

  const isPteActive = useMemo(
    () =>
      [
        "/pte-core",
        "/pte-online-coaching",
        "/pte-coaching-classes-parramatta",
        "/pte-coaching-sydney",
      ].includes(activePath),
    [activePath]
  );

  const isNaatiActive = useMemo(
    () =>
      [
        "/naati-ccl-online-coaching",
        "/naati-coaching-classes-parramatta",
        "/naati-ccl-coaching-sydney",
      ].includes(activePath),
    [activePath]
  );

  const isCoursesActive = useMemo(
    () => coursesPaths.includes(activePath),
    [activePath, coursesPaths]
  );

  useEffect(() => {
    const path = location.pathname;

    const shouldCheckLocation =
      !path.includes("/auth") ||
      path === "/auth/login" ||
      path === "/auth/register";

    if (shouldCheckLocation) {
      setIsIndia(detectIndia());
    }
  }, [location.pathname]);

  // const isTransparent = isDesktop && hasHeroImage && !isScrolled;

  // Event handlers - useCallback to prevent recreation
  const toggleLoginDropdown = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isLoginOpen) {
        setIsCoursesOpen(false);
        setOpenSubmenu(null);
    }
    setIsLoginOpen((prev) => !prev);
  }, [isLoginOpen]);

  const toggleCoursesDropdown = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLoginOpen(false);
    setIsCoursesOpen((prev) => {
      if (!prev) setOpenSubmenu(null);
      return !prev;
    });
  }, []);

  const toggleSubmenu = useCallback((submenu, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Close other top-level dropdowns if opening a new top-level submenu
    const isTopLevel = ["Our Apps", "Resources"].includes(submenu);
    if (isTopLevel) {
        setIsCoursesOpen(false);
        setIsLoginOpen(false);
    }

    setOpenSubmenu((prev) => (prev === submenu ? null : submenu));
  }, []);

  const handleClickOutside = useCallback((e) => {
    if (!e.target.closest(".accordion-item") && !e.target.closest(".nav-item.dropdown")) {
      setOpenSubmenu(null);
      setIsCoursesOpen(false);
      setIsLoginOpen(false);
    }
  }, []);

  const handleNavClick = useCallback((path) => {
    setOpenSubmenu(null);
    setIsCoursesOpen(false);
    setIsLoginOpen(false);
  }, []);

  const openStaff = useCallback(() => {
    setStaffFlag((prev) => !prev);
  }, []);

 

 
  // Click outside listener
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [handleClickOutside]);

  // Memoized navigation items
  const navItems = useMemo(
    () => [
      
      {
        label: "Our Apps",
        children: [
          { label: "PTE App", path: "/pte-app" },
          { label: "NAATI CCL App", path: "/naati-app" },
        ],
      },
      { label: "Free Mock Test", path: "/mock-test" },
      {
        label: "Resources",
        children: [
          { label: "About Us", path: "/about" },
          { label: "Branches", path: "/branches" },
          { label: "Business", path: "/business" },
          { label: "Careers", path: "/join-us" },
          { label: "Video Course", path: "/video-courses" },
          { label: "Analyzer", path: "/scorecard-analyzer" },
          {label:"Blog" , path:"https://www.languageacademy.com.au/blog/" },
        ],
      },
      ...(isIndia
        ? [{ label: "PTE Voucher", path: "/exam-voucher" }]
        : []),
      { label: "Contact us", path: "/contact" },
    ],
    [isIndia]
  );

  return (
    <div className="mainHeader-container">
    <header className="mainHeader custom-container new-header-design">
      <div className="logoNav">
        <div className="container-fluid">
          <div className="row">
            <nav className="navbar navbar-expand-lg">
              <div className="container-fluid">
                <div className="header-mobile-wrapper">
                  <div className="navbar-brand">
                    <div className="header-logo new-logo">
                      <Link to={isMainSite ? "/" : "/auth/login"}>
                        <img
                          src={
                            // isMainSite ?
                                 NewLogo
                              // : `${base}${logoIcon || "/images/default-logo.png"}`
                          }
                          alt="logo"
                        />
                      </Link>
                    </div>
                  </div>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                </div>

                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav">
                    <li
                      className={`nav-item ${activePath === "/" ? "active" : ""}`}
                    >
                      <Link
                        className="nav-link"
                        to="/"
                        onClick={() => handleNavClick("/")}
                      >
                        Home
                      </Link>
                    </li>

                    {/* Courses Dropdown */}
                    <li
                      className={`nav-item dropdown ${
                        isCoursesActive ? "active" : ""
                      }`}
                      ref={coursesDropdownRef}
                    >
                      <a
                        className={`nav-link dropdown-toggle ${
                          isCoursesOpen ? "show" : ""
                        }`}
                        href="#"
                        onClick={toggleCoursesDropdown}
                        role="button"
                        aria-expanded={isCoursesOpen}
                      >
                        Courses
                      </a>
                      <ul
                        className={`dropdown-menu ${
                          isCoursesOpen ? "show" : ""
                        }`}
                      >
                        {/* PTE Submenu */}
                        <li className={`accordion-item ${openSubmenu === "pte" ? "open" : ""}`}>
                          <a
                            className={`dropdown-item d-flex justify-content-between align-items-center ${
                              isPteActive ? "active" : ""
                            }`}
                            href="#"
                            onClick={(e) => toggleSubmenu("pte", e)}
                            role="button"
                          >
                            PTE Coaching
                            <i className={`fa fa-chevron-${openSubmenu === "pte" ? "down" : "right"} submenu-arrow`}></i>
                          </a>
                          {openSubmenu === "pte" && (
                            <ul className="submenu-list show">
                              <li>
                                <Link
                                  className={`dropdown-item mt-1 ${
                                    activePath === "/pte-online-coaching"
                                      ? "active"
                                      : ""
                                  }`}
                                  to="/pte-online-coaching"
                                  onClick={() =>
                                    handleNavClick("/pte-online-coaching")
                                  }
                                >
                                  PTE Online Coaching
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className={`dropdown-item ${
                                    activePath === "/pte-coaching-classes-parramatta"
                                      ? "active"
                                      : ""
                                  }`}
                                  to="/pte-coaching-classes-parramatta"
                                  onClick={() =>
                                    handleNavClick("/pte-coaching-classes-parramatta")
                                  }
                                >
                                  PTE On-Campus Coaching
                                </Link>
                              </li>
                               <li>
                                <Link
                                  className={`dropdown-item ${
                                    activePath === "/pte-core" ? "active" : ""
                                  }`}
                                  to="/pte-core"
                                  onClick={() => handleNavClick("/pte-core")}
                                >
                                  PTE Core Coaching
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>

                        {/* NAATI CCL Submenu */}
                        <li className={`accordion-item ${openSubmenu === "naati" ? "open" : ""}`}>
                          <a
                            className={`dropdown-item d-flex justify-content-between align-items-center ${
                              isNaatiActive ? "active" : ""
                            }`}
                            href="#"
                            onClick={(e) => toggleSubmenu("naati", e)}
                            role="button"
                          >
                            NAATI CCL Coaching
                            <i className={`fa fa-chevron-${openSubmenu === "naati" ? "down" : "right"} submenu-arrow`}></i>
                          </a>
                          {openSubmenu === "naati" && (
                            <ul className="submenu-list show">
                              <li>
                                <Link
                                  className={`dropdown-item mt-1 ${
                                    activePath === "/naati-ccl-online-coaching"
                                      ? "active"
                                      : ""
                                  }`}
                                  to="/naati-ccl-online-coaching"
                                  onClick={() =>
                                    handleNavClick("/naati-ccl-online-coaching")
                                  }
                                >
                                  Naati CCL Online Coaching
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className={`dropdown-item ${
                                    activePath === "/naati-coaching-classes-parramatta"
                                      ? "active"
                                      : ""
                                  }`}
                                  to="/naati-coaching-classes-parramatta"
                                  onClick={() =>
                                    handleNavClick("/naati-coaching-classes-parramatta")
                                  }
                                >
                                  Naati CCL On-Campus Coaching
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>

                        {/* IELTS */}
                        <li className="accordion-item">
                          <Link
                            className={`dropdown-item py-2 d-flex justify-content-between align-items-center ${
                              activePath === "/ielts-coaching-parramatta"
                                ? "active"
                                : ""
                              }`}
                              to="/ielts-coaching-parramatta"
                            onClick={() =>
                              handleNavClick("/ielts-coaching-parramatta")
                            }
                          >
                            IELTS Coaching
                          </Link>
                        </li>
                      </ul>
                    </li>

                    {/* Other Navigation Items */}
                    {navItems.map((item) => {  
                      const isActive = item.children?.some(
                        (child) => activePath === child.path
                      );
                     return item.children ? (
                        <li
                          key={item.label}
                          className={`nav-item dropdown ${
                            isActive ? "active" : ""
                          }`}
                        >
                          <a
                            className={`nav-link dropdown-toggle ${
                              isActive ? "active" : ""
                            }`}
                            href="#"
                            onClick={(e) => toggleSubmenu(item.label, e)}
                            role="button"
                          >
                            {item.label}
                          </a>

                          <ul
                            className={`dropdown-menu ${
                              openSubmenu === item.label ? "show" : ""
                            }`}
                          >
                           {item.children.map((child) => {
                              const isExternal = /^https?:\/\//i.test(child.path);
                              return (
                                <li key={child.path} className="accordion-item">
                                  {isExternal ? (
                                    <a
                                      className="dropdown-item py-2 d-flex justify-content-between align-items-center"
                                      href={child.path}
                                    >
                                      {child.label}
                                    </a>
                                  ) : (
                                    <Link
                                      className={`dropdown-item py-2 d-flex justify-content-between align-items-center ${
                                        activePath === child.path ? "active" : ""
                                      }`}
                                      to={child.path}
                                      onClick={() => handleNavClick(child.path)}
                                    >
                                      {child.label}
                                    </Link>
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      ) : (
                        <li
                          key={item.path}
                          className={`nav-item ${
                            activePath === item.path ? "active" : ""
                          }`}
                        >
                          <Link
                            className="nav-link"
                            to={item.path}
                            onClick={() => handleNavClick(item.path)}
                          >
                            {item.label}
                          </Link>
                        </li>
                      )}
                    )}

                    {/* <li className="nav-item">
                      <a
                        className="nav-link"
                        href="https://www.languageacademy.com.au/blog/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Blog
                      </a>
                    </li> */}

                    <li className="nav-item">
                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        className="book-call-btn"
                      >
                        Book A Call
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_7617_42963)">
                            <path
                              d="M10.5353 4.5C11.2678 4.64292 11.9411 5.00119 12.4688 5.52895C12.9966 6.05671 13.3549 6.72995 13.4978 7.4625M10.5353 1.5C12.0572 1.66908 13.4765 2.35063 14.56 3.43276C15.6435 4.51488 16.3268 5.93326 16.4978 7.455M7.66803 10.3973C6.76684 9.49612 6.05525 8.47714 5.53325 7.38992C5.48835 7.2964 5.4659 7.24965 5.44866 7.19048C5.38736 6.98021 5.43139 6.72202 5.5589 6.54395C5.59478 6.49384 5.63765 6.45097 5.72338 6.36524C5.98558 6.10303 6.11669 5.97193 6.2024 5.84009C6.52565 5.34293 6.52565 4.70199 6.2024 4.20482C6.11669 4.07299 5.98559 3.94189 5.72338 3.67968L5.57723 3.53353C5.17865 3.13495 4.97936 2.93566 4.76532 2.8274C4.33965 2.6121 3.83695 2.6121 3.41128 2.8274C3.19724 2.93566 2.99795 3.13495 2.59937 3.53353L2.48114 3.65176C2.08393 4.04897 1.88532 4.24758 1.73363 4.51761C1.56532 4.81724 1.4443 5.28261 1.44532 5.62627C1.44624 5.93598 1.50632 6.14765 1.62647 6.57098C2.2722 8.84603 3.49056 10.9928 5.28154 12.7838C7.07253 14.5748 9.2193 15.7931 11.4943 16.4389C11.9177 16.559 12.1293 16.6191 12.4391 16.62C12.7827 16.621 13.2481 16.5 13.5477 16.3317C13.8177 16.18 14.0164 15.9814 14.4136 15.5842L14.5318 15.466C14.9304 15.0674 15.1297 14.8681 15.2379 14.654C15.4532 14.2284 15.4532 13.7257 15.2379 13.3C15.1297 13.086 14.9304 12.8867 14.5318 12.4881L14.3856 12.3419C14.1234 12.0797 13.9923 11.9486 13.8605 11.8629C13.3633 11.5397 12.7224 11.5397 12.2252 11.8629C12.0934 11.9486 11.9623 12.0797 11.7001 12.3419C11.6144 12.4277 11.5715 12.4705 11.5214 12.5064C11.3433 12.6339 11.0851 12.678 10.8749 12.6167C10.8157 12.5994 10.7689 12.577 10.6754 12.5321C9.58819 12.0101 8.56921 11.2985 7.66803 10.3973Z"
                              stroke="#94C23C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_7617_42963">
                              <rect width="18" height="18" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </li>

                    {/* Login or Dashboard */}
                    {isLoggedIn ? (
                      <li className="login">
                        <Link
                          className="login-btn new-login-btn"
                          to="/admin/dashboard"
                          onClick={() => handleNavClick("/admin/dashboard")}
                        >
                          <span>
                          <i className="fa fa-lock" aria-hidden="true"></i>
                          Dashboard
                          </span>
                        </Link>
                      </li>
                    ) : (
                      <>
                        {/* Desktop: Login Dropdown */}
                        <li
                          className="login-dropdown dropdown d-none d-lg-block"
                          ref={loginDropdownRef}
                          onMouseEnter={() => setIsLoginOpen(true)}
                          onMouseLeave={() => setIsLoginOpen(false)}
                        >
                          <Link
                           className={`login-btn new-login-btn  ${
                              isLoginOpen ? "show" : ""
                            }`}
                            to="/auth/login"
                            onClick={() => handleNavClick("/auth/login")}
                          >
                            <span>
                            <img
                              src="/images/web-new-images/icons/log-in.svg"
                              alt="Login"
                              />
                            Login
                            <img src={loginArrow} className="dropdown-arrow" alt="arrow" />
                              </span>
                          </Link>
                          <ul
                            className={`dropdown-menu ${
                              isLoginOpen ? "show" : ""
                            }`}
                            style={{
                              right: 0,
                              left: "auto",
                              minWidth: "220px",
                              marginTop: "15px",
                            }}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/auth/login"
                                onClick={() => handleNavClick("/auth/login")}
                              >
                                LA's PTE Portal
                              </Link>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="https://www.laccl.languageacademy.com.au/auth/login"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                LA's NAATI Portal
                              </a>
                            </li>
                          </ul>
                        </li>

                        {/* Mobile: Separate Buttons */}
                        {/* <li
                          className="login-dropdown d-lg-none"
                          style={{ marginTop: "10px" }}
                        >
                          <Link
                            className="login-btn new-login-btn"
                            to="/auth/login"
                            onClick={() => handleNavClick("/auth/login")}
                          >
                            <span>
                              <img
                                src="/images/web-new-images/icons/log-in.svg"
                                alt="Login"
                              />
                              Login
                              <img src={loginArrow} className="dropdown-arrow" alt="arrow" />
                            </span>
                          </Link>
                        </li> */}
                        <li
                          className="login-dropdown d-lg-none"
                          style={{ marginTop: "10px", marginBottom: "10px" }}
                        >
                          <Link
                            className="login-btn new-login-btn"
                            to="/auth/login"
                            onClick={() => handleNavClick("/auth/login")}
                          >
                            <span>
                              <img
                                src="/images/web-new-images/icons/log-in.svg"
                                alt="Login"
                              />{" "}
                              LA's PTE Portal
                            </span>
                          </Link>
                        </li>
                        <li className="nav-item d-lg-none">
                          <a
                            className="book-call-btn"
                            href="https://www.laccl.languageacademy.com.au/auth/login"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/images/web-new-images/icons/log-in.svg"
                              alt="Login"
                              style={{ width: "22px" }}
                            />
                            LA's NAATI Portal
                          </a>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
                              </div>
  );
});

Header.displayName = "Header";

export default Header;